<template>
  <div class="payment-boleto-sucess">
    <div class="success">
      <AmIconMaterial
        class="success__icon text--green"
        name="check_circle"
        size="md"
      />
      <AmTypography
        :text="$t('steps.payment.billet.success')"
        text-color="success"
        typography-style="l6"
        weight="bold"
      />
    </div>
    <BilletMessage />
    <div v-if="billet.digitable_line">
      <AmTypography
        class="payment-boleto-sucess__boleto"
        :text="billet.digitable_line"
        typography-style="l5"
        weight="bold"
      />

      <input
        id="billetCode"
        :value="billet.digitable_line"
        type="text"
        readonly
      />

      <AmButton
        :class="`payment-boleto-sucess__copy ${theme.color}`"
        label="Copiar código do boleto"
        color="blue"
        size="xl"
        full-width
        @click="copyData()"
      />
    </div>

    <AmButton
      :class="`payment-boleto-sucess__download ${theme.color} button__outlined--${theme.color}`"
      label="Baixar boleto"
      color="blue"
      size="xl"
      type="outlined"
      full-width
      :icon="iconDownload"
      @click="billetDownload()"
    />
    <br />
    <div id="redirectButtonText">
      <AmTypography
        :text="$t('steps.payment.shopify.paymentSucess')"
        typography-style="l6"
        text-color="success"
        weight="bold"
      />
    </div>
    <br />
    <AmButton
      :class="`next ${theme.color}`"
      :label="buttonLabel"
      size="xl"
      full-width
      @click="returnToStore()"
    />
  </div>
</template>

<script>
import BilletMessage from '@/views/Checkout/partials/steps/Payment/payments/PaymentBillet/BilletMessage/BilletMessage.vue'
import themeMixin from '@/components/mixins/themeMixin'
import copyTextClipboard from '@/utils/copyTextToClipboard'
import { mapState } from 'vuex'
import { injectPixelScript } from '@/utils/pixels/injectPixelScript'
import { pixelPurchaseParams } from '@/utils/pixels/pixelPurchaseParams'

export default {
  name: 'PaymentBilletSucess',
  components: {
    BilletMessage,
  },
  mixins: [themeMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          digitable_line: null,
        }
      },
    },
    paymentSuccessData: {
      type: Object,
    },
  },
  data() {
    return {
      iconDownload: {
        name: 'download',
        position: 'left',
        type: 'material',
        size: 'xl',
      },
    }
  },
  computed: {
    billet() {
      return this.value
    },
    buttonLabel() {
      return this.$t('returnToStore')
    },
    ...mapState('Checkout', {
      cart: (state) => state.cart,
      pixels: (state) => state.pixels,
    }),
  },
  mounted() {
    this.loadCheckoutPixel()
  },
  methods: {
    returnToStore() {
      window.location.href = this.paymentSuccessData.redirect_url
    },
    copyData() {
      copyTextClipboard('#billetCode')

      this.$AmAlert({
        type: 'success',
        description: 'Código copiado',
        autoHide: true,
      })
    },
    billetDownload() {
      window.open(this.billet.pdf)
    },
    loadCheckoutPixel() {
      try {
        const pixels = pixelPurchaseParams(this.pixels, this.cart, 'boleto_order')

        if (pixels.length) {
          injectPixelScript(pixels, 'purchase')
        }
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-boleto-sucess {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  &__boleto {
    width: 100%;
    text-align: center;
    padding: 13px 5px 13px 5px;
    border: 1px solid #d2d6de;
    box-sizing: border-box;
    border-radius: 4px;
    margin: 74px auto auto;
    word-break: break-all;
  }
  &__copy {
    margin-top: 38px;
  }
  &__download {
    margin-top: 10px;
  }
  .success {
    display: flex;
    justify-content: center;
    margin: 10px;

    &__icon {
      margin-right: 10px;
    }
  }
  #billetCode {
    display: none;
  }
  #redirectButtonText {
    display: flex;
    margin: 0 auto;
  }
}
</style>
